import { 
  FormControl, 
  FormControlLabel, 
  Radio, 
  RadioGroup, 
  Stack, 
  styled as muiStyled, 
  TextField, 
  Typography, 
  Divider, 
  Chip
} from "@mui/material";
import styled from "styled-components";
import Button from "../../../../../components/Button";
import Modal from "../../../../../components/Modal";
import { COLORS } from "../../../../../themes/colors";

export const ModalStyled = styled(Modal)`
  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 5px 8px rgba(0, 0, 0, 0.14), 0px 1px 14px rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  width: 424px;

  &.Modal__window {
    z-index: 100;
  }

  .Modal__content {
    padding: 24px 28px;
  }
`;

export const DateModalContainer = styled.div``;

export const HeaderDateModal = styled.header`
  padding: 16px 24px;
  border-radius: 8px 8px 0 0;
  background-color: var(--luft-primary);
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const HeaderTitle = styled.span`
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
  color: var(--white);
`


export const Container = muiStyled(Stack)(() => ({
  flexDirection: 'column',
  marginTop: '4px',
  marginBottom: '8px',
}));

export const DateContainer = muiStyled(Stack)(() => ({
  flexDirection: 'column',
  marginTop: '4px',
  marginBottom: '8px',
  width: '100%',
  gap: '8px'
}));

export const DateContent = muiStyled(Stack)(() => ({
  flexDirection: 'row',
  alignItems: 'flex-end',
  justifyContent: 'center',
  gap: '24px',
  width: '100%',
  maxWidth: '286px',
  marginBottom: '32px'
}));

export const PeriodTitle = muiStyled(Typography)(() => ({
  fontFamily: 'Work Sans',
  fontWeight: 600,
  fontSize: '14px',
  color: `${COLORS.DARK['+3']}`,
}));

export const DividerStyled = muiStyled(Divider)(() => ({
  marginTop: '8px',
}));


export const TextFieldStyled = muiStyled(TextField)(() => ({
  color: `${COLORS.DARK['+5']}`,
  fontFamily: 'Work Sans',
  fontWeight: 400,
  fontSize: '14px',

  '& .MuiInput-underline:before': {
    borderBottom: `1px solid ${COLORS.DARK['+1']}`,
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: `${COLORS.PRIMARY.BLUE['-4']}`,
  },
}));

export const FormControlStyled = muiStyled(FormControl)(() => ({}));

export const RadioGroupStyled = muiStyled(RadioGroup)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignSelf: 'flex-start',
}));

export const FormLabelStyled = muiStyled(FormControlLabel)(() => ({
  color: `${COLORS.DARK['+5']}`,
  fontFamily: 'Work Sans',
}));

export const LabelStyled = muiStyled(Typography)(() => ({
  fontFamily: 'Work Sans',
  fontWeight: 400,
  fontSize: '14px',
}));

export const RadioStyled = muiStyled(Radio)(() => ({
  color: `${COLORS.PRIMARY.BLUE['-4']}`,
  '&.Mui-checked': {
    color: `${COLORS.PRIMARY.BLUE['-4']}`,
  },
}));

export const ChipsStack = muiStyled(Stack)(() => ({
  flexWrap: 'wrap',
}))

export const StyledButton = muiStyled(Button)(() => ({
  boxShadow: '0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px rgba(0, 0, 0, 0.14), 0px 1px 5px rgba(0, 0, 0, 0.12)',
  borderRadius: '8px',
}))


export const StyledChip = muiStyled(Chip)(() => ({
  fontFamily: 'Work Sans',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '13px',
  lineHeight: '18px',
  backgroundColor: 'transparent',
  border: '1px solid #1077B990',
  color: '#1077B9',

  '&.MuiChip-colorSecondary': {
    background: '#1077B925',
    '&:hover': {
    backgroundColor: '#1077B995',
  },

  },

  '&:hover': {
    backgroundColor: '#1077B925',
  },

}));
